import { render, staticRenderFns } from "./delivery-task-add-or-update.vue?vue&type=template&id=05411f76&scoped=true&"
import script from "./delivery-task-add-or-update.vue?vue&type=script&lang=js&"
export * from "./delivery-task-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./delivery-task-add-or-update.vue?vue&type=style&index=0&id=05411f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05411f76",
  null
  
)

export default component.exports